var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-cover'),_c('home-image-divider-a',{staticClass:"home-divisor-a"}),_c('home-tecnologia',{staticClass:"mt-n5 home-tecnologia"}),_c('home-aplicativo',{staticClass:"rf-margin home-aplicativo"}),_c('home-image-divider-b',{staticClass:"home-divisor-b"}),_c('home-avaliacoes',{staticClass:"home-avaliacoes"}),_c('home-email')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }